import { Configuration, LogLevel, PopupRequest } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';

export const msalConfig: Configuration = {
    auth: {
    clientId: environment.azure.clientId, 
    authority: `https://login.microsoftonline.com/${environment.azure.tenantId}`,
    redirectUri: environment.azure.redirectUri, 
    postLogoutRedirectUri: environment.azure.redirectUriLogout
    },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        // if (!containsPii) {
        //   switch (level) {
        //     case LogLevel.Error: console.error(message); break;
        //     case LogLevel.Info: console.info(message); break;
        //     case LogLevel.Verbose: console.debug(message); break;
        //     case LogLevel.Warning: console.warn(message); break;
        //   }
        // }
      }
    }
  }
};

export const loginRequest: PopupRequest = {
    scopes: ['User.Read'] 
};
